{
  "skipToContent": "Skip to content",
  "reel": {
    "hint": "Scroll for the next step ↓",
    "prev": "← Prev",
    "next": "Next →",
    "position": "Step {{index}} of {{count}}"
  },
  "cta": {
    "eyebrow": "The next step",
    "defaultTitle": "Ready to start, or want to know more?",
    "explorer": "Try DEC Explorer",
    "contact": "Talk to our experts",
    "contactShort": "Contact us",
    "howItWorks": "How it works"
  },
  "eyebrow": {
    "successStory": "Success story",
    "caseReal": "Real case",
    "persona": "Who it's for"
  },
  "blog": {
    "heading": "News and insights",
    "sub": "Visit our blog for articles on renewable energy, sustainability and the latest industry news.",
    "allLink": "All articles"
  },
  "stats": [
    {
      "prefix": "up to",
      "target": 25,
      "suffix": "%",
      "label": "in savings on your energy costs"
    },
    {
      "prefix": "up to",
      "target": 20,
      "suffix": "k€",
      "label": "of extra EBITDA per GWh"
    },
    {
      "target": 15,
      "suffix": "min",
      "label": "granularity of production data, in real time"
    },
    {
      "target": 100,
      "suffix": "%",
      "label": "production tracked and certified by the GSE"
    }
  ],
  "nav": {
    "companies": "For companies",
    "producers": "For producers",
    "resources": "Resources",
    "solutions": "Solutions",
    "whoWeServe": "Who we serve",
    "howItWorks": "How it works",
    "aboutUs": "About us",
    "home": "Home",
    "login": "Login",
    "contact": "Contact us",
    "switchToProducers": "Are you a producer?",
    "switchToCompanies": "Are you a company?",
    "switchTitle": "Switch to the other version of the site",
    "decExplorer": "DEC Explorer",
    "decExplorerDesc": "The numbers behind your consumption",
    "faq": "FAQ",
    "faqDesc": "Frequently asked questions",
    "blog": "DEC insights",
    "blogDesc": "Discover the latest articles and news",
    "solutionLabels": {
      "riduzione-prevedibile": "Predictable energy cost reduction",
      "ebitda": "Improve your operating profitability",
      "conformita": "Future-proof and profitable compliance",
      "copertura-naturale": "Reduce energy cost volatility",
      "impatto": "An energy transition you can show"
    },
    "solutionCategories": {
      "riduzione-prevedibile": "Cut costs",
      "ebitda": "EBITDA",
      "conformita": "ESG compliance",
      "copertura-naturale": "Hedging",
      "impatto": "Impact"
    },
    "roleLabels": {
      "ipp-light": "Small producer",
      "ipp": "IPP",
      "utility": "Utility"
    },
    "roleDescs": {
      "ipp-light": "Small and medium plants",
      "ipp": "Growing portfolios",
      "utility": "Cash without touching the NFP"
    },
    "mainLabel": "Main navigation",
    "closeMenu": "Close menu",
    "openMenu": "Open menu",
    "companiesShort": "Companies",
    "producersShort": "Producers",
    "investors": "For investors",
    "investorsShort": "Investors",
    "footer": {
      "description": "Energy transition\nmade profitable.",
      "rights": "All rights reserved.",
      "tagline": "We contract off-site active renewable plants, for companies and producers.",
      "disclaimer": "DEC Energy SA does not supply electricity.",
      "colCompanies": "Companies",
      "colProducers": "Producers",
      "colResources": "Resources",
      "overview": "Overview",
      "howItWorks": "How it works",
      "aboutUs": "About us",
      "contacts": "Contacts",
      "privacy": "Privacy policy"
    }
  },
  "notFound": {
    "eyebrow": "Error 404",
    "title": "This page",
    "highlight": "does not exist",
    "subtitle": "The link may be outdated, or the address mistyped. From here you can go back to the home page or write to us.",
    "primaryLabel": "Back to home",
    "secondaryLabel": "Contact us"
  },
  "fields": {
    "surface_type": {
      "roof": "Roof",
      "land (agricultural)": "Land\n (Agricultural)",
      "land (industrial)": "Land \n(Industrial)"
    }
  },
  "form": {
    "error": "Something went wrong. Please try again shortly."
  },
  "quotes": {
    "label": "Quotes"
  },
  "calendly": {
    "cookie": "To use the booking calendar you need to accept third-party cookies.\n Alternatively, you can use our contact form.",
    "contact-form": "Contact form",
    "contact": "For any questions, contact us at ",
    "accept-cookies": "Accept cookies",
    "booking": {
      "meet-title": "Meet DEC Energy",
      "tz-cet": "Central European Time ({{time}})",
      "select-date-time": "Select a Date & Time",
      "timezone": "Time zone",
      "next": "Next",
      "enter-details": "Enter Details",
      "confirmed": "You are scheduled!",
      "confirmation-message": "A calendar invitation has been sent to {{email}}.",
      "join-meet": "Join Google Meet Call",
      "schedule-another": "Schedule another meeting",
      "prev-month": "Previous month",
      "next-month": "Next month",
      "meeting-duration": "Meeting duration",
      "duration-heading": "Meeting duration",
      "duration-15": "in-depth overview of the DEC Energy model",
      "duration-45": "free tailored savings analysis and in-depth overview of the DEC Energy model",
      "no-slots": "No times available for this duration.",
      "field-required": "This field is required",
      "email-invalid": "Enter a valid email address",
      "phone-invalid": "Enter a valid phone number",
      "selected-time": "Selected time",
      "submitting": "Booking your meeting…",
      "submitting-hint": "We're creating your appointment and Google Meet link, this can take a few seconds.",
      "select-duration": "Select duration",
      "form": {
        "fields": {
          "guest_name": {
            "label": "Full Name"
          },
          "guest_email": {
            "label": "Email Address"
          },
          "company_name": {
            "label": "Company Name"
          },
          "phone_number": {
            "label": "Phone Number"
          },
          "notes": {
            "label": "Notes"
          }
        },
        "submit": "Schedule Event",
        "back": "Change date & time"
      }
    }
  },
  "accept-banner": {
    "header": "Cookie consent",
    "message": "By clicking accept you consent to the use of cookies to improve your experience and analyze site traffic. For more details, see our",
    "privacy-policy-link": "privacy policy.",
    "accept": "Accept",
    "reject": "Reject"
  },
  "company": {
    "next-steps": {
      "title": "<h2>Ready to get started or need more information?</h2>",
      "description": "Select how to proceed:",
      "tag": "NEXT STEP",
      "calc": "Go to DEC explorer",
      "contact": "Contact our experts",
      "contact-us": "For any questions, contact us at"
    }
  },
  "producer": {
    "next-steps": {
      "title": "<h2>Ready to get started \nor need more information?</h2>",
      "contact": "Contact our experts",
      "contact-us": "For any questions, contact us at"
    }
  },
  "byAuthor": "by {{author}}",
  "waterfall": {
    "today": "Today",
    "result": "Result"
  }
}
